import styled from 'styled-components';

import { scrollDirections } from 'hooks/useScrollDirection';

const getTopPosition = direction => {
  const directions = {
    [scrollDirections.UP]: '0',
    [scrollDirections.DOWN]: '-60px',
    [scrollDirections.IDLE]: '0',
  };

  return directions[direction];
};

export const Container = styled.div`
  width: 100%;
  min-height: 60px;
  display: flex;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  box-shadow: 0 10px 30px 0 rgb(82 63 105 / 8%);
  border-bottom: 1px solid #ebedf3;
  z-index: 2;
  transition: all 0.4s ease;
  padding: 20px;
  user-select: none;

  @media screen and (min-width: 992px) {
    background-color: #f4f5f7;
    top: ${({ scrollDirection }) => getTopPosition(scrollDirection)};
    padding: 0 20px;
  }

  .nav-menus {
    margin: 0 auto;
    width: 100%;

    .hamburger-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .hamburger {
        padding: 9px;
        cursor: pointer;
      }
    }

    .menu-container {
      display: ${({ isMenuActive }) => (isMenuActive ? 'block' : 'none')};

      @media screen and (min-width: 992px) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    @media screen and (min-width: 992px) {
      max-width: 1200px;
      padding-left: 12px;
      padding-right: 12px;
    }

    .menu {
      @media screen and (min-width: 992px) {
        display: flex;
        align-items: center;
      }

      > * {
        @media screen and (min-width: 992px) {
          margin-right: 15px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 30px;

  .link {
    text-decoration: none;
  }

  .link:hover {
    color: #185335;
    text-decoration: none;
    cursor: pointer;
  }

  .img {
    width: 40px;
    height: auto;
    margin-right: 10px;
  }

  .title {
    display: inline-block;
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
  }
`;

export const LoggedUserContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 8px;
  }

  .avatar-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: #dfe1e5;
    font-weight: bold;
    box-shadow: inset 0 0 10px rgb(0 0 0 / 25%);
  }

  .title {
    font-weight: bold;
    font-size: 0.875rem;

    &::after {
      content: '▾';
      display: inline-block;
      margin-left: 4px;
      font-size: 18px;
      color: rgb(24, 83, 53);
    }
  }
`;

export const SubMenuContainer = styled.div`
  overflow: auto;

  @media screen and (min-width: 992px) {
    overflow: unset;

    display: flex;

    > * {
      margin-right: 70px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;
